import { Helmet } from 'react-helmet-async';
import servicesList from '../data/services';
import Service from '../components/Service';
import SectionPageTitle from '../components/SectionPageTitle';

export default function Services() {
	return (
		<>
			<Helmet>
				<title>Services</title>
				<meta name="description" content="Gersem Services for Business Services & IT Solutions to your business" />
				<meta name="keywords" content="services, it servies, solution service" />
			</Helmet>

			<SectionPageTitle
				pageTitle={'Services'} 
				subTitle={'Our it partner'}
			/>

			<section className="container">
				<div className="grid gtc-3 g-2">
					{servicesList.map(service =>
						<Service
							key={service.slug}
							icon={service.icon}
							slug={service.slug}
							title={service.title}
							text={service.text}
						/>
					)}
				</div>
			</section>
		</>
	);
}
